export default __webpack_public_path__ + "static/media/bench.05ef6c42.png";